<eze-modal #waiverModal>
	<eze-modal-header>
		<h1>{{ header }}</h1>
	</eze-modal-header>
	<eze-modal-content>
		<div [innerText]="waiverText" class="waiverText"></div>
	</eze-modal-content>
	<eze-modal-footer>
		<eze-button (click)="waiverModal.close()">Close</eze-button>
	</eze-modal-footer>
</eze-modal>
